import { PhoneNumberUtil } from "google-libphonenumber";
import { string } from "yup";

export const valueIsAtLeast2LongAndOnlyNumbers = (inputString: string) => {
  return inputString.length >= 2 && /^[0-9]+$/.test(inputString);
};

const emailValidator = string().email();
export const validateEmail = (email: string) => {
  try {
    emailValidator.validateSync(email);
    return true;
  } catch (_e) {
    return false;
  }
};

const phoneUtil = PhoneNumberUtil.getInstance();
const isPhoneValid = (phone: string, countryCode: string) => {
  try {
    return phoneUtil.isPossibleNumber(
      phoneUtil.parse("+" + countryCode + phone)
    );
  } catch (error) {
    return false;
  }
};

export const isEmailOrPhoneMode = (value: string) => {
  if (value.length < 2) {
    return "Unsure";
  } else if (valueIsAtLeast2LongAndOnlyNumbers(value)) {
    return "Phone";
  } else {
    return "Email";
  }
};

export const isValidToContinue = (value: string, countryCode: string) => {
  if (value === "") {
    return false;
  }
  const isValidEmail = validateEmail(value);
  const isValidPhone = isPhoneValid(value, countryCode);

  return isValidEmail || isValidPhone;
};
